import * as React from 'react'
import { Component } from 'react'
import * as _ from 'lodash'
import store from '../../../../stores/forms_data_store'
import Select from '../../../shared/base_react_select'

export default class TrackedClicksFilterForm extends Component {
  defaultValues: any
  listener: any
  debouncedEmailSearch: any

  constructor(props) {
    super(props)

    this.defaultValues = {
      startAt: null,
      endAt: null,
      userEmail: '',
      selectedLocation: null,
      selectedTemplate: null,
      formRef: this,
    }

    store.init('by-type', this.defaultValues)

    this.listener = store.addListener('UpdateProjectExpensesFormView', () => this.forceUpdate())

    // Debounce email search to avoid excessive API calls
    this.debouncedEmailSearch = _.debounce((value) => {
      store.assign('by-type', 'userEmail', value)
      this.forceUpdate()
      store.trigger('FilterClicked')
    }, 500)
  }

  componentWillUnmount() {
    this.listener.remove()
    this.debouncedEmailSearch.cancel()
  }

  filtersData() {
    return {
      start_at: store.forms['by-type'].startAt || null,
      end_at: store.forms['by-type'].endAt || null,
      user_email: store.forms['by-type'].userEmail || null,
      location_id: store.forms['by-type'].selectedLocation?.id || null,
      template_id: store.forms['by-type'].selectedTemplate?.id || null,
    }
  }

  onChangeDate(e, field) {
    const value = e.target.value
    store.assign('by-type', field, value)
    this.forceUpdate()
    store.trigger('FilterClicked')
  }

  onChangeEmail(e) {
    const value = e.target.value
    this.debouncedEmailSearch(value)
  }

  onChangeSelect(val, field) {
    store.assign('by-type', field, val)
    this.forceUpdate()
    store.trigger('FilterClicked')
  }

  onClickClear(e) {
    e.preventDefault()
    store.init('by-type', this.defaultValues)
    this.forceUpdate()
    store.trigger('FilterClicked')
  }

  render() {
    return (
      <div id="tracked_clicks_filters_form" className="d-flex mb-4 border-bottom pb-4">
        <div className="default-form-input-wrapper flex-grow-2 mr-3">
          <label htmlFor="tracked-clicks-filter-start-at">{this.props.formData.placeholders.startAt}</label>
          <input
            id="tracked-clicks-filter-start-at"
            type="date"
            className="form-control"
            placeholder={this.props.formData.placeholders.startAt}
            value={store.get('by-type', 'startAt') || ''}
            onChange={(e) => this.onChangeDate(e, 'startAt')}
          />
        </div>
        <div className="default-form-input-wrapper flex-grow-2 mr-3">
          <label htmlFor="tracked-clicks-filter-end-at">{this.props.formData.placeholders.endAt}</label>
          <input
            id="tracked-clicks-filter-end-at"
            type="date"
            className="form-control"
            placeholder={this.props.formData.placeholders.endAt}
            value={store.get('by-type', 'endAt') || ''}
            onChange={(e) => this.onChangeDate(e, 'endAt')}
          />
        </div>
        <div className="default-form-input-wrapper flex-grow-1 mr-3">
          <label htmlFor="tracked-clicks-filter-user-email">{this.props.formData.placeholders.searchUserEmail}</label>
          <input
            id="tracked-clicks-filter-user-email"
            type="text"
            className="form-control mr-2"
            defaultValue={store.get('by-type', 'userEmail')}
            onChange={(e) => this.onChangeEmail(e)}
          />
        </div>
        <div className="default-form-input-wrapper flex-grow-1 mr-3">
          <label htmlFor="tracked-clicks-filter-location">{this.props.formData.placeholders.selectLocation}</label>
          <Select
            id="tracked-clicks-filter-location"
            value={store.get('by-type', 'selectedLocation')}
            options={this.props.formData.locations || []}
            isClearable
            getOptionLabel={(option) => option.name}
            getOptionValue={(option) => option.id.toString()}
            onChange={(v) => this.onChangeSelect(v, 'selectedLocation')}
          />
        </div>
        <div className="default-form-input-wrapper flex-grow-1 mr-3">
          <label htmlFor="tracked-clicks-filter-template">{this.props.formData.placeholders.selectTemplate}</label>
          <Select
            id="tracked-clicks-filter-template"
            value={store.get('by-type', 'selectedTemplate')}
            options={this.props.formData.templates || []}
            isClearable
            getOptionLabel={(option) => option.name}
            getOptionValue={(option) => option.id.toString()}
            onChange={(v) => this.onChangeSelect(v, 'selectedTemplate')}
          />
        </div>
        <div className="default-form-input-wrapper mr-2">
          <label className="w-100">&nbsp;</label>
          <button className="btn btn-secondary" onClick={(e) => this.onClickClear(e)}>
            {this.props.formData.clearBtCaption}
          </button>
        </div>
      </div>
    )
  }
}
